/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum DepreciationBasis {
  Value = 0,
  Cost = 1,
}
